export const BankIconSm = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.5003 9.79178H2.50033C1.70033 9.79178 1.04199 9.13345 1.04199 8.33345V5.56677C1.04199 5.00011 1.43364 4.42511 1.95864 4.21678L9.45864 1.2168C9.77531 1.0918 10.2253 1.0918 10.542 1.2168L18.042 4.21678C18.567 4.42511 18.9587 5.00844 18.9587 5.56677V8.33345C18.9587 9.13345 18.3003 9.79178 17.5003 9.79178ZM10.0003 2.3668C9.96699 2.3668 9.93368 2.36676 9.91701 2.37509L2.4253 5.37512C2.3753 5.40012 2.29199 5.50844 2.29199 5.56677V8.33345C2.29199 8.45011 2.38366 8.54178 2.50033 8.54178H17.5003C17.617 8.54178 17.7087 8.45011 17.7087 8.33345V5.56677C17.7087 5.50844 17.6337 5.40012 17.5753 5.37512L10.0753 2.37509C10.0587 2.36676 10.0337 2.3668 10.0003 2.3668Z"
      fill={strokeColor}
    />
    <path
      d="M18.3337 18.9583H1.66699C1.32533 18.9583 1.04199 18.675 1.04199 18.3333V15.8333C1.04199 15.0333 1.70033 14.375 2.50033 14.375H17.5003C18.3003 14.375 18.9587 15.0333 18.9587 15.8333V18.3333C18.9587 18.675 18.6753 18.9583 18.3337 18.9583ZM2.29199 17.7083H17.7087V15.8333C17.7087 15.7167 17.617 15.625 17.5003 15.625H2.50033C2.38366 15.625 2.29199 15.7167 2.29199 15.8333V17.7083Z"
      fill={strokeColor}
    />
    <path
      d="M3.33301 15.6253C2.99134 15.6253 2.70801 15.342 2.70801 15.0003V9.16699C2.70801 8.82533 2.99134 8.54199 3.33301 8.54199C3.67467 8.54199 3.95801 8.82533 3.95801 9.16699V15.0003C3.95801 15.342 3.67467 15.6253 3.33301 15.6253Z"
      fill={strokeColor}
    />
    <path
      d="M16.667 15.6253C16.3253 15.6253 16.042 15.342 16.042 15.0003V9.16699C16.042 8.82533 16.3253 8.54199 16.667 8.54199C17.0087 8.54199 17.292 8.82533 17.292 9.16699V15.0003C17.292 15.342 17.0087 15.6253 16.667 15.6253Z"
      fill={strokeColor}
    />
    <path
      d="M19.1663 18.958H0.833008C0.491341 18.958 0.208008 18.6747 0.208008 18.333C0.208008 17.9913 0.491341 17.708 0.833008 17.708H19.1663C19.508 17.708 19.7913 17.9913 19.7913 18.333C19.7913 18.6747 19.508 18.958 19.1663 18.958Z"
      fill={strokeColor}
    />
    <path
      d="M10 7.70801C8.96667 7.70801 8.125 6.86634 8.125 5.83301C8.125 4.79967 8.96667 3.95801 10 3.95801C11.0333 3.95801 11.875 4.79967 11.875 5.83301C11.875 6.86634 11.0333 7.70801 10 7.70801ZM10 5.20801C9.65833 5.20801 9.375 5.49134 9.375 5.83301C9.375 6.17467 9.65833 6.45801 10 6.45801C10.3417 6.45801 10.625 6.17467 10.625 5.83301C10.625 5.49134 10.3417 5.20801 10 5.20801Z"
      fill={strokeColor}
    />
  </svg>
);
